import type { StrictSet, UserCapability } from '@joyful/utils'
import type { ComponentType } from 'react'
import { z } from 'zod'
import type { EncounterAdminFormProps } from './forms/EncounterAdminForm'

export const ActionPathSchema = z.enum([
  'research',
  'submitted:submit-appeal',
  'submitted:submit-documentation-details',
  'submitted:claim-resubmission',
  'submitted:confirmed-with-payer-batch-processing',
  'payer-action:found-payment',
  'payer-action:found-denial',
  'payer-action:found-rejection',
  'payer-action:found-recoupment',
  'snooze',
  'escalate',
  'place-call',
  'resolve:found-money',
  'resolve:uncollectible',
  'return-to-biller',
  'close',
  'qa-review',
  'check-eligibility',
  'draft-appeal',
  'submit-paper-claim',
])

export type ActionPath = z.infer<typeof ActionPathSchema>
type GetSubpaths<T extends string> = T extends `${infer First}:${infer Rest}`
  ? First | `${First}:${GetSubpaths<Rest>}`
  : T
export type ActionSubpath = GetSubpaths<ActionPath>

export interface ActionMetadatum {
  capability?: UserCapability | Array<UserCapability>
  columnSpan?: 'wide' | 'column'
  description?: string
  emoji: string
  enabledRequirements?: StrictSet<
    | 'coming-soon'
    | 'flagged-for-follow-up'
    | 'resolved'
    | 'closed'
    | 'not-in-queue'
    | 'not-in-progress-return-to-biller'
    | 'not-rejected'
    | 'not-resolved'
    | 'not-closed'
    | 'not-snoozed'
    | 'assigned-to-current-user'
  >
  formComponent?: ComponentType<
    Pick<
      EncounterAdminFormProps,
      'className' | 'onCancel' | 'title' | 'encounterId'
    >
  >
  keywords?: Array<string>
  title: string
}
